module.exports = __webpack_public_path__ + "static/img/2.5b54c54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/eng/2.png
// module id = 8Twg
// module chunks = 0